import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  profile: null,
};

const profileSlicer = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setProfile: (state, action) => {
        console.log(action.payload ,'action-------------')
      state.profile = action.payload;
    },
  },
});

export const { setProfile } = profileSlicer.actions;
export default profileSlicer.reducer;
